// extracted by mini-css-extract-plugin
export var animationContainer = "_fa-0";
export var asteriskIcon = "_fa-8";
export var conversationLeftSection = "_fa-4";
export var conversationListItem = "_fa-3";
export var conversationMiddleSection = "_fa-5";
export var conversationRightSection = "_fa-6";
export var detailsContent = "_fa-1";
export var listContainer = "_fa-7";
export var modalContent = "_fa-2";